import API_BASE_URL from '../config/api';

const authHeaders = () => {
  const token =
    typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getCart = async () => {
  const res = await fetch(`${API_BASE_URL}/cart`, {
    headers: { ...authHeaders() },
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json?.message || 'Failed to fetch cart');
  return json.data;
};

export const addToCart = async ({ productId, quantity = 1, color, size }) => {
  const res = await fetch(`${API_BASE_URL}/cart`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify({ productId, quantity, color, size }),
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json?.message || 'Failed to add to cart');
  return json.data;
};

export const updateCartItem = async (itemId, quantity) => {
  const res = await fetch(
    `${API_BASE_URL}/cart/${encodeURIComponent(itemId)}`,
    {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...authHeaders() },
      body: JSON.stringify({ quantity }),
    }
  );
  const json = await res.json();
  if (!res.ok) throw new Error(json?.message || 'Failed to update cart item');
  return json.data;
};

export const removeCartItem = async (itemId) => {
  const res = await fetch(
    `${API_BASE_URL}/cart/${encodeURIComponent(itemId)}`,
    {
      method: 'DELETE',
      headers: { ...authHeaders() },
    }
  );
  const json = await res.json();
  if (!res.ok) throw new Error(json?.message || 'Failed to remove cart item');
  return json.data;
};

export const clearCart = async () => {
  const res = await fetch(`${API_BASE_URL}/cart`, {
    method: 'DELETE',
    headers: { ...authHeaders() },
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json?.message || 'Failed to clear cart');
  return json.data;
};

export const getCartSummary = async () => {
  const res = await fetch(`${API_BASE_URL}/cart/summary`, {
    headers: { ...authHeaders() },
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json?.message || 'Failed to fetch cart summary');
  return json.data;
};

export const validateCart = async () => {
  const res = await fetch(`${API_BASE_URL}/cart/validate`, {
    method: 'POST',
    headers: { ...authHeaders() },
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json?.message || 'Failed to validate cart');
  return json.data;
};
